import React from 'react';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import AlertExecution from '@app/model/alert/AlertExecution';
import ParityPriceComparisonAlertExecutionNotificationOutput
	from '@app/model/alert/output/ParityPriceComparisonAlertExecutionNotificationOutput';
import ParityPriceComparisonNotificationRowFragment
	from '@app/site/secured/rateshopper/rates/alert-execution/fragment/parity-price-comparison/ParityPriceComparisonNotificationRowFragment';

const ParityPriceComparisonNotificationsFragment: React.FunctionComponent<{
	companyHotel: CompanyHotel,
	alertExecution: AlertExecution,
	notificationOutputs: ParityPriceComparisonAlertExecutionNotificationOutput[],
	isInDrawer?: boolean
}> = ({ companyHotel, alertExecution, notificationOutputs, isInDrawer = false }) => {

	const nights = alertExecution.alertOutput.alert.filter.lengthOfStay;

	return <section className="mt-8">
		<div className="mb-3 flex items-center justify-between">
			<h2 className="text-base font-semibold leading-6 text-gray-950">Parity Undercuts</h2>
			{nights && <p className="text-sm text-gray-500"><span className="font-semibold text-gray-950">{nights}</span> Nights Stay</p>}
		</div>
		<div className="space-y-4">
			{notificationOutputs.map(notificationOutput => <ParityPriceComparisonNotificationRowFragment
				companyHotel={companyHotel} alertExecution={alertExecution} key={notificationOutput.current.id}
				notificationOutput={notificationOutput}
				isInDrawer={isInDrawer} />)}
		</div>
	</section>;
};

export default ParityPriceComparisonNotificationsFragment;
